import { createSelector, createSlice } from '@reduxjs/toolkit';
import {
    getCropNutrition,
    getCropNutritionDetail,
    getCropsForProductByTypeAndTrialsCountry,
} from 'api/CropNutritionPrograms';
import { fetchWithLanguage } from 'store/helpers';

export const fetchCropNutritionPage = fetchWithLanguage('fetchCropNutrition', getCropNutrition, (_, { getState }) => {
    const { data } = getState().cropNutritionState.cropNutritionPage;
    return !data;
});
export const fetchCropNutritionDetail = fetchWithLanguage('fetchCropNutritionDetail', getCropNutritionDetail);
export const fetchCropNutritionForProduct = fetchWithLanguage(
    'fetchCropNutritionForProduct',
    getCropsForProductByTypeAndTrialsCountry,
);
export const fetchCropNutritionPageCrops = fetchWithLanguage(
    'fetchCropNutritionPageCrops',
    getCropsForProductByTypeAndTrialsCountry,
);

const cropNutritionSlice = createSlice({
    name: 'cropNutritionSlice',
    initialState: {
        cropNutritionPage: {},
        cropNutritionPageCrops: {},
        cropNutritionPageCropsIsLoading: false,
        cropNutritionDetail: {},
        cropNutritionForProduct: {},
        allCropNutritionForFilter: {
            data: [],
        },
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchCropNutritionPage.fulfilled, (state, action) => {
                state.cropNutritionPage = action.payload;
            })
            .addCase(fetchCropNutritionPageCrops.pending, (state, action) => {
                state.cropNutritionPageCropsIsLoading = true;
            })
            .addCase(fetchCropNutritionPageCrops.fulfilled, (state, action) => {
                state.cropNutritionPageCrops = action.payload;
                state.cropNutritionPageCropsIsLoading = false;
                if (!state.allCropNutritionForFilter.data.length) {
                    state.allCropNutritionForFilter = action.payload;
                }
            })
            .addCase(fetchCropNutritionDetail.fulfilled, (state, action) => {
                state.cropNutritionDetail = action.payload;
            })
            .addCase(fetchCropNutritionForProduct.fulfilled, (state, action) => {
                state.cropNutritionForProduct = action.payload;
            });
    },
});

export const selectCropNutritionPage = createSelector(
    [state => state.cropNutritionState.cropNutritionPage],
    cropNutritionPage => cropNutritionPage.data || {},
);

export const selectCropNutritionPageIsLoading = createSelector(
    [
        state => state.cropNutritionState.cropNutritionPage,
        state => state.cropNutritionState.cropNutritionPageCropsIsLoading,
    ],
    (cropNutritionPage, cropNutritionPageCropsIsLoading) =>
        cropNutritionPage.status !== 'success' && cropNutritionPageCropsIsLoading,
);

export const selectCropNutritionPageCrops = createSelector(
    [state => state.cropNutritionState.cropNutritionPageCrops],
    cropNutritionPageCrops => cropNutritionPageCrops.data || [],
);

export const selectAllCropNutritionForFilter = createSelector(
    [state => state.cropNutritionState.allCropNutritionForFilter],
    allCropNutritionForFilter => allCropNutritionForFilter.data || [],
);

export const selectAllCropNutritionOptions = createSelector([selectAllCropNutritionForFilter], data =>
    data.map(crop => ({
        value: crop.slug,
        name: crop.title,
    })),
);

export const selectCropNutritionDetail = createSelector(
    [state => state.cropNutritionState.cropNutritionDetail],
    cropNutritionDetail => cropNutritionDetail.data || {},
);

export const selectCropNutritionForProduct = createSelector(
    [state => state.cropNutritionState.cropNutritionForProduct],
    cropNutritionForProduct => cropNutritionForProduct || {},
);

export default cropNutritionSlice.reducer;
